import moment from "moment";
import NumeroALetras from "../../../../componentes/funciones/NumeroALetras";
import { NegocioConfig } from "../../../../configuracion/Empresa";
import { formatoMoneda } from "../../../../configuracion/validaciones"
import { ImprimirEnIframe } from "../../../../componentes/imprimir/ImprimirEnIframe";
import { generarPDF } from "../../../../componentes/imprimir/GenerarPDF";

export const ImprimirCierre = (data, usuario) => {
    if (!data) return;

    const cierre = data.nuevoCierre || data;
    const ingresosEgresos = data.ingresosEgresos || [];

    const {
        createdAt,
        efectivo = 0,
        pos = 0,
        transferencias = 0,
        id,
        efectivosistema = 0,
        possistema = 0,
        transferenciassistema = 0,
        totalventa = 0,
        totalcompra = 0,
        egreso = 0,
        ingreso = 0,
    } = cierre;

    const codigoCierre = id ? `CE-${String(id).padStart(5, "0")}` : "—";
    const totalCaja = parseFloat(efectivo) + parseFloat(pos) + parseFloat(transferencias);
    const empleadoNombre = usuario?.datoPersonales?.nombreCorto || "—";
    const usuarioId = usuario?.datoPersonales?.id || "—";
    const fechaHora = moment(createdAt || new Date()).format("DD-MM-YYYY HH:mm:ss");
    const logoSrc = NegocioConfig.logo;

    const html = `
    <div style="width:280px; font-family:'Arial', sans-serif; font-size:14px; color:black; padding:0; margin:0;">
        <img src="${logoSrc}" style="width:100px; height:100px; display:block; margin:0 auto;" alt="Logo" />
        <div style="text-align:center; margin-bottom:5px;">
            <div style="font-weight:bold; font-size:16px;">${NegocioConfig.nombre}</div>
            <div style="font-size:12px;">RTN: ${NegocioConfig.rtn}</div>
            <div style="font-size:12px;">${NegocioConfig.direccion}</div>
            <div style="font-size:12px;">Tel: ${NegocioConfig.telefono}</div>
        </div>

        <hr style="border:1px dashed black; margin: 5px 0;" />

        <div style="font-weight:bold; margin:5px 0; text-align: left; font-size:15px;">CIERRE DE CAJA No. ${codigoCierre}</div>
        <div style="text-align: left;"><span>Fecha:</span> ${fechaHora}</div>
        <div style="text-align: left;"><span>Responsable:</span> ${empleadoNombre}</div>
        <div style="text-align: left;"><span>ID Usuario:</span> ${usuarioId}</div>

        <hr style="border:1px dashed black; margin: 5px 0;" />

        <div style="margin:10px 0; font-size:13px;">
            <div style="font-weight:bold; text-align:center; margin-bottom:6px; background-color:#f0f0f0; padding:3px;">RESUMEN DE CAJA</div>
            <table style="width:100%; border-collapse:collapse;">
                <tr>
                    <td style="padding:2px 0;">Total Ventas (Sistema):</td>
                    <td style="text-align:right; padding:2px 0;">${formatoMoneda(totalventa)}</td>
                </tr>
                <tr>
                    <td style="padding:2px 0;">Total Compras (Sistema):</td>
                    <td style="text-align:right; padding:2px 0;">${formatoMoneda(totalcompra)}</td>
                </tr>
                <tr>
                    <td style="padding:2px 0;">Otros Ingresos:</td>
                    <td style="text-align:right; padding:2px 0;">${formatoMoneda(ingreso)}</td>
                </tr>
                <tr>
                    <td style="padding:2px 0;">Otros Egresos:</td>
                    <td style="text-align:right; padding:2px 0;">${formatoMoneda(egreso)}</td>
                </tr>
            </table>
        </div>

        <hr style="border:1px dashed black; margin: 5px 0;" />

        <div style="margin:10px 0; font-size:13px;">
            <div style="font-weight:bold; text-align:center; margin-bottom:6px; background-color:#f0f0f0; padding:3px;">TOTALES DEL SISTEMA</div>
            <table style="width:100%; border-collapse:collapse;">
                <tr>
                    <td style="padding:2px 0;">Efectivo (Sistema):</td>
                    <td style="text-align:right; padding:2px 0;">${formatoMoneda(efectivosistema)}</td>
                </tr>
                <tr>
                    <td style="padding:2px 0;">POS/Tarjeta (Sistema):</td>
                    <td style="text-align:right; padding:2px 0;">${formatoMoneda(possistema)}</td>
                </tr>
                <tr>
                    <td style="padding:2px 0;">Transferencias (Sistema):</td>
                    <td style="text-align:right; padding:2px 0;">${formatoMoneda(transferenciassistema)}</td>
                </tr>
            </table>
        </div>

        <hr style="border:1px dashed black; margin: 5px 0;" />

        <div style="margin:10px 0; font-size:13px;">
            <div style="font-weight:bold; text-align:center; margin-bottom:6px; background-color:#f0f0f0; padding:3px;">TOTALES CONTADOS EN CAJA</div>
            <table style="width:100%; border-collapse:collapse;">
                <tr>
                    <td style="padding:2px 0;">Efectivo (Contado):</td>
                    <td style="text-align:right; padding:2px 0;">${formatoMoneda(efectivo)}</td>
                </tr>
                <tr>
                    <td style="padding:2px 0;">POS/Tarjeta (Contado):</td>
                    <td style="text-align:right; padding:2px 0;">${formatoMoneda(pos)}</td>
                </tr>
                <tr>
                    <td style="padding:2px 0;">Transferencias (Contado):</td>
                    <td style="text-align:right; padding:2px 0;">${formatoMoneda(transferencias)}</td>
                </tr>
            </table>
        </div>

        <hr style="border:2px solid black; margin: 10px 0;" />

        <div style="margin-top:8px; font-size:12px; text-transform:uppercase; text-align: left; font-weight:500;">
            Total Final en Letras: ${NumeroALetras(totalCaja)}
        </div>
        <div style="font-size:14px; font-weight:bold; text-align: right; background-color: #dddddd; padding: 5px;">TOTAL CONTADO: ${formatoMoneda(totalCaja)}</div>

        <div style="text-align:center; margin-top:20px; font-size:14px;">
            <strong>¡Cierre generado exitosamente!</strong>
        </div>
    </div>
    `;
    ImprimirEnIframe(html, `Cierre de Caja ${codigoCierre}`, '5px');
    const nombrePDF = `Comprobante_Cierre_${codigoCierre}.pdf`;
    generarPDF(html, nombrePDF, 88);
};